export default "__VITE_ASSET__DJz_56Vn__"